import { Params } from "@angular/router";
import { NotificationTriggerModal } from "@core/models/auxiliary-company-models";
import { MainFilterRaw } from "@core/models/main-filter-view";
import { NotificationOperator } from "@core/models/notifications";
import { Nullable } from "@core/models/nullable";
import { ColumnMapping, DataFilter } from "@core/components/dynamic-table/dynamic-table.component";

export function iterateSortDirectionDataFilter(
    mainFilterRaw: DataFilter,
    column: ColumnMapping,
): DataFilter {
    if (mainFilterRaw.sortProperty === column.sortProperty) {
        switch (mainFilterRaw.sortDirection?.toLowerCase()) {
            case "asc":
                mainFilterRaw = { ...mainFilterRaw, sortDirection: "desc" };
                break;
            case "desc":
                mainFilterRaw = { ...mainFilterRaw, sortDirection: "asc" };
                break;
            default:
                mainFilterRaw = { ...mainFilterRaw, sortDirection: "desc" };
                break;
        }
    } else {
        mainFilterRaw = { ...mainFilterRaw, sortProperty: column.sortProperty!, sortDirection: "desc" };
    }
    return mainFilterRaw;
}
export function blockScroll() {
    document.body.classList.add("p-overflow-hidden");
}

export function unblockScroll() {
    document.body.classList.remove("p-overflow-hidden");
}

export function convertRawQueryStringToParams(query: string): Params {
    const p: Params = {};

    if (query == null) {
        return p;
    }

    query.split("&").forEach((pair) => {
        const [key, ...values] = pair.split("=");
        let value = values.join("");
        value = value == null ? "" : decodeURIComponent(value);

        if (p[key] != null) {
            //if already exists
            if (!Array.isArray(p[key])) {
                // and if not array
                p[key] = [p[key]]; // convert to array
            }
            p[key].push(value); // and push the value
        } else {
            p[key] = value;
        }
    });
    if (p['sortProperty'] !== "status") {
        delete p['thenSortProperty'];
        delete p['thenSortDirection'];
    }

    return p;
}

export function createNotificationTriggerModal(
    isActive = false,
    operator: NotificationOperator = ">=",
    value: Nullable<number> = null
): NotificationTriggerModal {
    return { isActive, operator, value };
}

export function getPageSize(mainFilterRaw: MainFilterRaw): number {
    return +(mainFilterRaw.pageSize ?? "100");
}


export function getSortDirection(mainFilterRaw: MainFilterRaw): "asc" | "desc" | undefined {
    switch (mainFilterRaw.sortDirection?.toLowerCase()) {
        case "asc":
            return "asc";
        case "desc":
            return "desc";
        default:
            return;
    }
}